import React, { useEffect, useState, useRef, useMemo } from "react";
import Request from "../../../../../helpers/request";
import * as url from "../../../../../helpers/url_helper";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import ConfirmationModal from "../../../../../components/Common/ConfirmationModal";
import { useDispatch, useSelector } from "react-redux";
import { useSocket } from "../../../../../Utils/socket";
import { OPERATE_MQTT } from "../../../../../helpers/socketEvent";
import OtaModel from "../OtaModal";
import ChipsDataTable from "./ChipsDataTable";
import {
  DeleteIcon,
  OtaIcon,
  PingIcon,
  LogIcon,
  MqttIcon,
  MqttBoxIcon,
  AssignIcon,
} from "../../../../../assets/svg";
import DataTable from "react-data-table-component";
import OtaMultiModel from "../OtaMultiModel";
import MqttBoxModel from "../MqttBoxModel";
import AssignRoomModal from "../AssignRoomModal";
import { ActionButton } from "../../../../../components/Common/button";
import { Modal, ModalBody, ModalFooter, ModalHeader,Button } from "reactstrap";
import DeviceBinding from "../DeviceBinding";
import WifiModal from "../WifiModal";
import { PendingAction } from "../Common/PendingTicker";
import ScheduleFormOffcanvas from "../ScheduleModel";


export interface ChipsControlProps {
  userId: any;
  selectedPremise?: any;
  onTouchCodeAlertsChange?: (actions: PendingAction[]) => void;
}
const userInfo = JSON.parse(localStorage.getItem("userInfo") || "{}");
export interface ChipsControlProps {
  userId: any;
  selectedPremise?: any;
}

export const BooleanToggle = ({
    checked,
    onChange,
    disabled = false,
    onText = "YES",
    offText = "NO",
    onColor = "#22c55e",
    offColor = "#f3f4f6",
  }: {
    checked: boolean;
    onChange: () => void;
    disabled?: boolean;
    onText?: string;
    offText?: string;
    onColor?: string;
    offColor?: string;
  }) => {
    const width = 50;
    const height = 24;
    const knobSize = 18;
    const padding = 3;
    const travel = width - knobSize - padding * 2;

    return (
      <button
        type="button"
        onClick={onChange}
        disabled={disabled}
        role="switch"
        aria-checked={checked}
        style={{
          position: "relative",
          width: `${width}px`,
          height: `${height}px`,
          padding: 0,
          border: checked ? `1px solid ${onColor}` : "1px solid #d1d5db",
          borderRadius: `${height / 2}px`,
          backgroundColor: checked ? onColor : offColor,
          cursor: disabled ? "not-allowed" : "pointer",
          opacity: disabled ? 0.6 : 1,
          overflow: "hidden",
          userSelect: "none",
          transition: "background-color 0.2s ease, border-color 0.2s ease",
        }}
      >
        {/* YES / NO text */}
        <span
          style={{
            position: "absolute",
            top: "50%",
            left: checked ? "7px" : "auto",
            right: checked ? "auto" : "7px",
            transform: "translateY(-50%)",
            fontSize: "10px",
            fontWeight: 700,
            lineHeight: 1,
            color: checked ? "#fff" : "#6b7280",
            pointerEvents: "none",
            transition: "all 0.2s ease",
          }}
        >
          {checked ? onText : offText}
        </span>

        {/* Real switch knob */}
        <span
          style={{
            position: "absolute",
            top: "2px",
            left: `${padding}px`,
            width: `${knobSize}px`,
            height: `${knobSize}px`,
            borderRadius: "50%",
            backgroundColor: "#fff",
            transform: `translateX(${checked ? travel : 0}px)`,
            transition: "transform 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
            boxShadow: "0 1px 3px rgba(0,0,0,0.25), 0 1px 2px rgba(0,0,0,0.12)",
            pointerEvents: "none",
          }}
        />
      </button>
    );
  };
  

const ChipsList = ({ userId, selectedPremise , onTouchCodeAlertsChange}: ChipsControlProps) => {
  const selectedRooms = useSelector(
    (state: any) => state.APIResponse.selectedRooms,
  );
  const socket: any = useSocket();
  const navigate = useNavigate();
  const [loading, setLoading] = useState<boolean>(false);
  const [isDeleteModalOpen, setDeleteModalOpen] = useState(false);
  const [deleteData, setDeleteData] = useState<any>();
  const [assignData, setAssignData] = useState<any>({});
  const [isReload, setReload] = useState<boolean>(false);
  const [isOtaModalOpen, setIsOtaModalOpen] = useState(false);
  const [isMultiOtaModalOpen, setIsMultiOtaModalOpen] = useState(false);
  const [isMqttBoxModalOpen, setIsMqttBoxModalOpen] = useState(false);
  const [isAssignRoomModalOpen, setIsAssignRoomModalOpen] = useState(false);
  const [MqttData, setMqttData] = useState<any>({});
  const [otaSlave, setOtaSlave] = useState<any>({});
  const [selectedRows, setSelectedRows] = useState<any[]>([]);
  const [chipData, setChipData] = useState<any[]>([]);
  const [isViewModalOpen, setIsViewModalOpen] = useState(false);
  const [selectedRowsData, setSelectedRowsData] = useState<any>({});
  const [offcanvasOpenBinding, setOffcanvasOpenBinding] = useState(false);
  const [isWifiModalOpen, setIsWifiModalOpen] = useState(false);
  const [scheduleModal, setScheduleModal] = useState(false);
  const [selectedSwitch, setSelectedSwitch] = useState<any>(null);
  const [selectedSwitchModelType, setSelectedSwitchModelType] = useState<string>("");
  const [sceneModal, setSceneModal] = useState(false);
  const [selectedSceneSwitch, setSelectedSceneSwitch] = useState<any>(null);
  const [selectedSceneModelType, setSelectedSceneModelType] = useState<string>("");
  // scene panel 
  const [addSceneModalOpen, setAddSceneModalOpen] = useState(false);
  const [selectedSwitchForScene, setSelectedSwitchForScene] = useState<any>(null);
  const [availableScenes, setAvailableScenes] = useState<any[]>([]);
  const [scenesLoading, setScenesLoading] = useState(false);
  const [selectedSceneToAssign, setSelectedSceneToAssign] = useState<string | null>(null);
  const [expandedSceneDevicesId, setExpandedSceneDevicesId] = useState<string | null>(null);
  const [assigningScene, setAssigningScene] = useState(false);
  const [isDeleteSceneModalOpen, setIsDeleteSceneModalOpen] = useState(false);
  const [deleteSceneRow, setDeleteSceneRow] = useState<any>(null);
  const [deletingScene, setDeletingScene] = useState(false);
  const [isScheduleFormOpen, setIsScheduleFormOpen] = useState(false);
  const [editingSchedule, setEditingSchedule] = useState<any>(null);
  const [deletingScheduleId, setDeletingScheduleId] = useState<string | null>(null);

  const isScenePanelType = (modelType?: string) =>
    (modelType || "").toUpperCase().endsWith("SC");

  const openAddSceneModal = (row: any) => {
    setSelectedSwitchForScene(row);
    setAddSceneModalOpen(true);
    fetchScenesList();
  };

  const closeAddSceneModal = () => {
    setAddSceneModalOpen(false);
    setSelectedSwitchForScene(null);
    setAvailableScenes([]);
    setSelectedSceneToAssign(null);
    setExpandedSceneDevicesId(null);
  };

  const buildScenesListPayload = () => ({
    draw: 1,
    order: [],
    start: 0,
    length: 1000,
    search: { value: "", regex: false },
    userId,
    premiseId: selectedPremise?.id ?? selectedPremise,
    roomId:
      selectedRooms && selectedRooms.length > 0
        ? selectedRooms.map((r: any) => (typeof r === "string" ? r : r.id)).join(",")
        : "noroom",
  });

  const fetchScenesList = async () => {
    try {
      setScenesLoading(true);
      const response = await Request.post(
        `${url.BASE_URL}${url.GET_SCENE_LIST}`,
        buildScenesListPayload(),
      );

      const rows = response.data?.data;

      setAvailableScenes(Array.isArray(rows) ? rows : []);
    } catch (error: any) {
      console.error("FETCH SCENE LIST ERROR:", error);
      toast.error(error?.response?.data?.msg || "Failed to load scenes");
      setAvailableScenes([]);
    } finally {
      setScenesLoading(false);
    }
  };
  
  const handleAssignSceneSubmit = async () => {
    if (!selectedSceneToAssign) {
      toast.error("Please select a scene");
      return;
    }
    try {
      setAssigningScene(true);
      const payload = {
        chipSwitchId: selectedSwitchForScene?._id,
        linkedSwitchOrScenes: [{ executeSceneId: selectedSceneToAssign }],
      };
      const response = await Request.post(url.ASSIGN_SCENE_PANEL, payload);
      toast.success(response?.data?.msg || "Scene assigned successfully");
      closeAddSceneModal();
      handleRefresh();
    } catch (error: any) {
      console.error("ASSIGN SCENE ERROR:", error);
      toast.error(error?.response?.data?.msg || "Failed to assign scene");
    } finally {
      setAssigningScene(false);
    }
  };
  
  const handleDeleteSceneClick = (row: any) => {
    setDeleteSceneRow(row);
    setIsDeleteSceneModalOpen(true);
  };
  
  const closeDeleteSceneModal = () => {
    setIsDeleteSceneModalOpen(false);
    setDeleteSceneRow(null);
  };

  const deleteSceneAssignApiCall = async () => {
    if (!deleteSceneRow) return;
    try {
      setDeletingScene(true);
      const payload = {
        chipSwitchId: deleteSceneRow._id,
        linkedSwitchOrScenes: [],
      };
      const response = await Request.post(url.ASSIGN_SCENE_PANEL, payload);
      toast.success(response?.data?.msg || "Scene removed successfully");
      closeDeleteSceneModal();
      handleRefresh();
    } catch (error: any) {
      console.error("DELETE SCENE ASSIGN ERROR:", error);
      toast.error(error?.response?.data?.msg || "Failed to remove scene");
    } finally {
      setDeletingScene(false);
    }
  };
  
  const alertSlaveAirModel = useMemo(() => {
    const allowedHwVersions = ["2.0.1", "2.0.2", "2.0.3"];
    
    return chipData
    .filter(
      (chip: any) =>
        allowedHwVersions.includes(chip.hwVersion) &&
          chip.modelType.startsWith("Air_"),
      )
      .map((chip: any) => ({
        slave: chip.slave,
        roomName: chip.roomName,
        modelType: chip.modelType,
        hwVersion: chip.hwVersion,
      }));
    }, [chipData]);
    
    useEffect(() => {
      if (!onTouchCodeAlertsChange) return;
    
      onTouchCodeAlertsChange(
        alertSlaveAirModel.map((chip) => ({
          type: `touch-code-${chip.slave}`,
          message: `Touch code update required in Slave ${chip.slave} - ${chip.roomName} (Model: ${chip.modelType}, HW: ${chip.hwVersion})`,
        })),
      );
    }, [alertSlaveAirModel]);
    
    // clear the ticker entries when the Chips tab unmounts
    useEffect(() => {
      return () => onTouchCodeAlertsChange?.([]);
    }, []);

  const openScheduleModal = (row: any, modelType?: string) => {
    setSelectedSwitch(row);
    setSelectedSwitchModelType(modelType || "");
    setScheduleModal(true);
  };

  const closeScheduleModal = () => {
    setSelectedSwitch(null);
    setSelectedSwitchModelType("");
    setScheduleModal(false);
  };

  const getScheduleId = (schedule: any) => schedule?.scheduleId || schedule?._id;

  const handleEditSchedule = async (schedule: any) => {

    setEditingSchedule({
      ...schedule,
      chipSwitchId: selectedSwitch?._id,
      deviceName: selectedSwitch?.displayName,
      deviceType: "chip",
    });
    closeScheduleModal();
    setIsScheduleFormOpen(true);
  };

  const closeScheduleForm = () => {
    setIsScheduleFormOpen(false);
    setEditingSchedule(null);
  };

  const handleDeleteSchedule = async (schedule: any) => {
    const scheduleId = getScheduleId(schedule);
    if (!scheduleId || deletingScheduleId) return;

    try {
      setDeletingScheduleId(scheduleId);
      const response = await Request.delete(
        `${url.BASE_URL}${url.DELETE_USER_SCHEDULE}`,
        {scheduleId : scheduleId},
      );
      toast.success(response?.data?.msg || "Schedule deleted successfully");

      // remove the row from the open modal right away
      setSelectedSwitch((prev: any) =>
        prev
          ? {
              ...prev,
              schedules: (prev.schedules || []).filter(
                (s: any) => getScheduleId(s) !== scheduleId,
              ),
            }
          : prev,
      );

      handleRefresh();
    } catch (error: any) {
      console.error("DELETE SCHEDULE ERROR:", error);
      toast.error(error?.response?.data?.msg || "Failed to delete schedule");
    } finally {
      setDeletingScheduleId(null);
    }
  };

  const openSceneModal = (row: any, modelType?: string) => {
    setSelectedSceneSwitch(row);
    setSelectedSceneModelType(modelType || "");
    setSceneModal(true);
  };

  const closeSceneModal = () => {
    setSelectedSceneSwitch(null);
    setSelectedSceneModelType("");
    setSceneModal(false);
  };

  // remote and main light not show in posh  
  const modelType = selectedRowsData?.modelType?.toUpperCase() || "";
  const hideIrAndMainLight = !modelType.startsWith("AIR")

  const columns = [
    {
      name: "Slave",
      selector: (row: any) => row.slave || "-",
      sortable: true,
      wrap: true,
    },
    {
      name: "Room",
      selector: (row: any) => row.roomName || "-",
      sortable: true,
      wrap: true,
    },
    // {
    //   name: "HW-V",
    //   selector: (row: any) => row.hwVersion || "-",
    //   sortable: true,
    //   grow: 0.5,

    //   wrap: true,
    // },
    // {
    //   name: "WI-V",
    //   selector: (row: any) => row.wifiVersion || "-",
    //   sortable: true,
    //   wrap: true,
    //   grow: 0.5,
    // },

    {
      name: "WI-V(HW-V)",
      selector: (row: any) =>
        `${row.wifiVersion || "-"} (${row.hwVersion || "-"})`,
      sortable: true,
      grow: 0.5,
      wrap: true,
    },
    {
      name: "tsw(thw)",

      selector: (row: any) => `${row.tsw || "-"} (${row.thw || "-"})`,
      sortable: true,
      wrap: true,
      grow: 0.5,
    },

    {
      name: "Model",
      selector: (row: any) => row.modelType || "-",
      grow: 0.5,
      sortable: true,
    },
    {
      name: "Status",
      selector: (row: any) => (row.isOnline ? "Online" : "Offline"),
      cell: (row: any) =>
        row.isOnline === true ? (
          <span className="font-size-11 badge-soft-success badge bg-secondary">
            online
          </span>
        ) : (
          <span className="font-size-11 badge-soft-danger badge bg-secondary">
            Offline
          </span>
        ),
      sortable: true,
      grow: 0.5,
      wrap: true,
    },

    {
      name: "Signal",
      selector: (row: any) => (row.signalStrength ? row.signalStrength : 0),
      cell: (row: any) => (
        <div>
          <span style={{ fontWeight: "bold", color: "black" }}>
            {row.signalStrength || "-"}
          </span>{" "}
          ({row.ssid || "-"})
        </div>
      ),
      sortable: true,
      wrap: true,
    },

     {
      name:"TouchType/Mcu Brand",
      cell: (row: any) => (
        <div>
          {row?.touchType ? row?.touchType : "-"}/{row?.mcu_brand ? row?.mcu_brand : "-"}
        </div>
      ),
      sortable: true,
      wrap: true
    },
    {
      name: "Actions",
      grow: 2,
      cell: (row: any) => (
        <div className="d-flex align-items-center" style={{ gap: "12px" }}>
          <ActionButton
            id="ViewIconButton"
            title="View"
            icon={
              <i
                className="bx bx-info-circle"
                style={{
                  fontSize: "24px",
                  color: "#667085",
                  cursor: "pointer",
                }}
              ></i>
            }
            onClick={() => handleViewClick(row)}
          />
          <ActionButton
            id="DeleteIconButton"
            title="Delete"
            icon={<DeleteIcon />}
            onClick={() => handleDeleteClick(row)}
          />
          <ActionButton
            id="PingIconButton"
            title="Ping"
            icon={<PingIcon />}
            onClick={() => handlePingClick(row)}
          />
          <ActionButton
            id="OTAIconButton"
            title="OTA"
            icon={<OtaIcon />}
            onClick={() => handleOtaClick(row)}
          />
          {/* <ActionButton
            id="LogIconButton"
            title="Log"
            icon={<LogIcon />}
             onClick={() => handleLogClick(row)}
          /> */}
          <ActionButton
            id="MQTTLogsIconButton"
            title="MQTT Logs"
            icon={<MqttIcon />}
            onClick={() => handleMQTTData(row)}
          />
          <ActionButton
            id="MQTTBoxIconButton"
            title="MQTT Box"
            icon={<MqttBoxIcon />}
            onClick={() => handleMqttBoxClick(row)}
          />
          <ActionButton
            id="AssignIconButton"
            title="Assign Room"
            icon={<AssignIcon />}
            onClick={() => handleAssignClick(row)}
          />
        </div>
      ),
    },
  ];

  const handleRefresh = () => {
    setReload((prev) => !prev);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      handleRefresh();
    }, 30000);

    return () => clearInterval(interval);
  }, []);

  const handleMQTTData = (row: any) => {
    row?.slave
      ? window.open(`/debug-device-details/${row?.slave}`, "_blank")
      : "";
  };
  // const handleLogClick = (row: any) => {
  //   row?.slave ? navigate(`/users/profile/device/${row?.slave}`) : "";
  // };

  const updateChipSwitch = async (
    row: any,
    updates: {
      displayName?: string;
      isFav?: boolean;
      inWidget?: boolean;
      isHide?: boolean;
    },
  ) => {
    try {
      if (
        updates.displayName !== undefined &&
        updates.displayName.trim() === (row.displayName || "").trim()
      ) {
        return;
      }
      setLoading(true);
      const payload = {
        chipSwitchId: row._id,
        ...updates,
      };
      const response = await Request.post(url.EDIT_CHIPS_DETAILS, payload);
      toast.success(response?.data?.msg);
      handleRefresh();
    } catch (error: any) {
      console.error("UPDATE CHIP SWITCH ERROR:", error);
      toast.error(error?.response?.data?.msg);
    } finally {
      setLoading(false);
    }
  };


  const handleTouchLockClick = (chipRow: any, switchRow: any) => {
    if (!switchRow) return;

    const newState = !switchRow.touchLock;
    const buttonCode = String(switchRow.button).padStart(2, "0");

    const reqObj = {
      slave: chipRow?.slave,
      cmd: "TL",
      tag: `airpanel-${userInfo?.id}`,
      data: `${buttonCode}${newState ? "Y" : "N"}`,
    };

    socket.emit(OPERATE_MQTT, JSON.stringify(reqObj));

    handleRefresh();
    toast.success(
      `Touch lock ${newState ? "enabled" : "disabled"} for switch ${
        switchRow.button
      }`,
    );
  };
  
  const EditableDisplayName = ({
    row,
    onSave,
  }: {
    row: any;
    onSave: (value: string) => Promise<void>;
  }) => {
    const [editing, setEditing] = useState(false);
    const [value, setValue] = useState(row.displayName || "");

    const inputRef = useRef<HTMLInputElement>(null);

    useEffect(() => {
      setValue(row.displayName || "");
    }, [row.displayName]);

    useEffect(() => {
      if (editing) {
        setTimeout(() => {
          inputRef.current?.focus();
          inputRef.current?.select();
        }, 0);
      }
    }, [editing]);

    const startEditing = () => {
      setValue(row.displayName || "");
      setEditing(true);
    };

    const saveDisplayName = async () => {
      const newValue = value.trim();
      const oldValue = (row.displayName || "").trim();

      if (!newValue) {
        toast.error("Display name is required");
        setValue(row.displayName || "");
        setEditing(false);
        return;
      }

      try {
        await onSave(newValue);
        setEditing(false);
      } catch (error) {
        // Keep input open if API fails
        console.error("Display name update failed:", error);
      }
    };

    const handleKeyDown = async (e: React.KeyboardEvent<HTMLInputElement>) => {
      if (e.key === "Enter") {
        e.preventDefault();
        await saveDisplayName();
      }
    };

    if (editing) {
      return (
        <input
          ref={inputRef}
          type="text"
          value={value}
          onChange={(e) => setValue(e.target.value)}
          onBlur={saveDisplayName}
          maxLength={18}
          onKeyDown={handleKeyDown}
          style={{
            width: "100%",
            minWidth: "140px",
            border: "none",
            color: "#343a40",
            background: "transparent",
          }}
        />
      );
    }

    return (
      <div className="d-flex align-items-center gap-2">
        <span>{row.displayName || "-"}</span>

        <button
          type="button"
          className="btn btn-sm  p-0"
          onClick={startEditing}
          title="Edit display name"
        >
          <i className="bx bx-edit-alt text-primary fs-5"></i>
        </button>
      </div>
    );
  };

  const ExpandedComponent = ({ data }: { data: any }) => {
    // const showAssignedSceneColumn = data.switches?.some(
    //   (item: any) => item.assignedScene,
    // );
    const showAssignedSceneColumn = data.modelType.toUpperCase().endsWith("SC")
    const switchColumns: any[] = [
      {
        name: "Display Name",
        selector: (row: any) => row.displayName || "-",
        sortable: true,
        grow: 1.5,
        cell: (row: any) => (
          <EditableDisplayName
            row={row}
            onSave={async (newName) => {
              await updateChipSwitch(row, {
                displayName: newName,
              });
            }}
          />
        ),
      },
      {
        name: "Button",
        selector: (row: any) => row.button,
        sortable: true,
      },
      ...(showAssignedSceneColumn
        ? [
            {
              name: "Assigned Scene",
              grow: 2,
              sortable: true,
              cell: (row: any) =>
                 row.assignedScene ? (
                  <div className="d-flex align-items-center gap-2">
                    <span
                      className="badge bg-light text-dark border d-inline-flex align-items-center gap-1 px-2 py-1 shadow-sm "
                      style={{ fontSize: "12px" }}
                    >
                      <i className="bx bx-layer" style={{ color: "#7C3AED" }}></i>
                      {row.assignedScene.sceneName}
                    </span>
                    <i
                      className="bx bx-trash text-danger"
                      style={{ cursor: "pointer", fontSize: "16px" }}
                      title="Remove scene"
                      onClick={() => handleDeleteSceneClick(row)}
                    ></i>
                  </div>
                ) : (
                  <button
                    type="button"
                    className="btn btn-sm d-inline-flex align-items-center justify-content-center gap-1 rounded-2 shadow-sm"
                    onClick={() => openAddSceneModal(row)}
                    style={{
                      minWidth: "42px",
                      height: "24px",
                      fontSize: "12px",
                      padding: "4px 8px",
                      backgroundColor: "#f3f5f3",
                      color: "#000000"
                    }}
                  >
                    <i className="bx bx-plus font-size-14"></i>
                    <span>Add</span>
                  </button>
                ),
            },
          ]
        : []),
      {
        name: "Type",
        selector: (row: any) => (row.type === 1 ? "Dimmer" : "Switch"),
        sortable: true,
      },

      {
        name: "Status",
        selector: (row: any) => (row.isOn ? "true" : "false"),
        cell: (row: any) =>
          row.isOn === true ? (
            <span className="font-size-11 badge-soft-success badge bg-secondary">
              true
            </span>
          ) : (
            <span className="font-size-11 badge-soft-danger badge bg-secondary">
              false
            </span>
          ),
        sortable: true,
      },
      {
        name: "Touch Lock",
        selector: (row: any) => (row.touchLock ? "true" : "false"),
        cell: (row: any) => (
          <BooleanToggle
            checked={!!row.touchLock}
            onChange={() => handleTouchLockClick(data, row)}
          />
        ),
        sortable: true,
      },
      {
        name: "Favourite",
        selector: (row: any) => (row?.isFav ? "true" : "false"),
        sortable: true,
        cell: (row: any) => (
          <BooleanToggle
            checked={!!row.isFav}
            onChange={() => {
              updateChipSwitch(row, {
                isFav: !row.isFav,
              });
            }}
          />
        ),
      },
      {
        name: "Widget",
        selector: (row: any) => (row.inWidget ? "true" : "false"),
        sortable: true,
        cell: (row: any) => (
          <BooleanToggle
            checked={!!row.inWidget}
            onChange={() => {
              updateChipSwitch(row, {
                inWidget: !row.inWidget,
              });
            }}
          />
        ),
      },
      {
        name: "Hidden",
        selector: (row: any) => (row.isHide ? "true" : "false"),
        sortable: true,
        cell: (row: any) => (
          <BooleanToggle
            checked={!!row.isHide}
            onChange={() => {
              updateChipSwitch(row, {
                isHide: !row.isHide,
              });
            }}
          />
        ),
      },
      {
        name: "Dimmer Value",
        selector: (row: any) => row.dimmerValue,
        sortable: true,
      },
      {
        name: "Schedules",
        // selector: (row: any) => row.she,
        center: true,
        cell: (row: any) => (
          <button
            type="button"
            className={`btn btn-sm d-inline-flex align-items-center justify-content-center gap-1 rounded-2 ${
              row.schedules?.length ? "btn-primary" : "btn-secondary"
            }`}
            disabled={!row.schedules?.length}
            onClick={() => openScheduleModal(row, data.modelType)}
            style={{
              minWidth: "42px",
              height: "24px",
              fontSize: "12px",
              padding: "4px 8px",
            }}
          >
            <i className="bx bx-calendar font-size-14"></i>
            <span>{row.schedules?.length || 0}</span>
          </button>
        ),
      },
      {
        name: "Scenes",
        center: true,
        width: "110px",
        cell: (row: any) => (
          <button
            type="button"
            className={`btn btn-sm d-inline-flex align-items-center justify-content-center gap-1 rounded-2 ${
              row.usedInScenes?.length ? "btn-success" : "btn-secondary"
            }`}
            disabled={!row.usedInScenes?.length}
            onClick={() => openSceneModal(row, data.modelType)}
            style={{
              minWidth: "42px",
              height: "24px",
              fontSize: "12px",
              padding: "4px 8px",
            }}
          >
            <i className="bx bx-layer font-size-15"></i>
            <span>{row.usedInScenes?.length || 0}</span>
          </button>
        ),
      },
    ];

    return (
      <div className="p-2">
        <DataTable
          columns={switchColumns}
          data={data.switches || []}
          dense
          highlightOnHover
          noDataComponent="No switches available"
          customStyles={customStyles}
        />
      </div>
    );
  };

  const handleDeleteClick = (row: any) => {
    setDeleteModalOpen(!isDeleteModalOpen);
    setDeleteData(row);
  };

  const deleteChipApiCall = () => {
    setLoading(true);
    const reqObj = {
      chipId: deleteData.id,
    };
    Request.post(url.DELETE_CHIP, reqObj)
      .then((res) => {
        // areaListApiCall()
        toast.success(res.data.msg);
        handleRefresh();
        setDeleteModalOpen(false);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        // showToast("error", err.response.data.errors[0]?.msg)
      });
  };
  const handlePingClick = (row: any) => {
    if (row !== undefined) {
      const reqObj = {
        slave: row?.slave,
        tag: `airpanel-${userInfo?.id}`,
        cmd: "PG",
      };
      console.log("ping", reqObj);
      socket.emit(OPERATE_MQTT, JSON.stringify(reqObj));
      handleRefresh();
      toast.success(`Ping sent to slave ${row?.slave}`);
    }
  };

  const handlePingAll = () => {
    if (selectedRows.length > 0) {
      selectedRows?.forEach((item) => {
        const reqObj = {
          slave: item.slave,
          tag: `airpanel-${userInfo?.id}`,
          cmd: "PG",
        };
        socket.emit(OPERATE_MQTT, JSON.stringify(reqObj));
      });
      handleRefresh();
      toast.success(
        `Ping successfully sent to ${selectedRows?.length} slaves.`,
      );
    }
  };
  const handleDsAll = () => {
    if (selectedRows.length > 0) {
      selectedRows?.forEach((item) => {
        const reqObj = {
          slave: item.slave,
          tag: `airpanel-${userInfo?.id}`,
          cmd: "DS",
        };
        socket.emit(OPERATE_MQTT, JSON.stringify(reqObj));
      });
      handleRefresh();
      toast.success(`DS successfully sent to ${selectedRows?.length} slaves.`);
    }
  };
  const handleUpdateWifiAll = () => {
    if (selectedRows.length > 0) {
      setIsWifiModalOpen(true);
    }
  };
  const handleDeleteAll = () => {
    if (selectedRows.length > 0) {
      toast.info("This feature will be available soon.");
    }
  };

  const handleOtaClick = (row: any) => {
    if (row !== undefined) {
      setIsOtaModalOpen(!isOtaModalOpen);
      setOtaSlave(row);
    }
  };
  const handleAssignClick = (row: any) => {
    if (row !== undefined) {
      setIsAssignRoomModalOpen(!isAssignRoomModalOpen);
      setAssignData(row);
    }
  };
  const handleMqttBoxClick = (row: any) => {
    if (row !== undefined) {
      setIsMqttBoxModalOpen(!isMqttBoxModalOpen);
      setMqttData(row);
    }
  };
  const handleOtaAll = () => {
    if (selectedRows.length > 0) {
      setIsMultiOtaModalOpen(!isMultiOtaModalOpen);
    }
  };
  const handleViewClick = (row: any) => {
    if (row !== undefined) {
      setIsViewModalOpen(!isViewModalOpen);
      setSelectedRowsData(row);
    }
  };
  const handleBinding = () => {
    setOffcanvasOpenBinding(!offcanvasOpenBinding);
  };
  const toggleRequestModel = () => {
    setIsViewModalOpen(!isViewModalOpen);
    setSelectedRowsData({});
  };

  const sendHardwareCommand = (
    row: any,
    key: "recall" | "ir_set" | "mainlit" | "backlit",
  ) => {
    const currentValue = !!selectedRowsData[key];

    const reqObj = {
      cmd: "HW",
      tag: `airpanel-${userInfo?.id}`,
      slave: `${row.slave}`,
      sub_cmd: key,
      data: currentValue ? "D" : "E",
      serial: Math.floor(Math.random() * 90000) + 10000,
    };

    socket.emit(OPERATE_MQTT, JSON.stringify(reqObj));

    setSelectedRowsData((prev: any) => ({
      ...prev,
      [key]: !currentValue,
    }));
    handleRefresh();

    toast.success(
      `${key.replace("_", " ")} ${currentValue ? "disabled" : "enabled"}`,
    );
  };

  const SettingCard = ({
    title,
    description,
    field,
  }: {
    title: string;
    description: string;
    field: "recall" | "ir_set" | "mainlit" | "backlit";
  }) => (
    <div className="col-md-6 mb-3">
      <div
        className="border rounded-3 p-3 h-100"
        style={{
          background: "#fff",
          boxShadow: "0 2px 10px rgba(0,0,0,.05)",
        }}
      >
        <div className="d-flex justify-content-between align-items-center">
          <div>
            <h6 className="mb-1 fw-bold">{title}</h6>

            <small className="text-muted">{description}</small>

            <div className="mt-2">
              <span
                className={`badge ${
                  selectedRowsData[field] ? "bg-success" : "bg-secondary"
                }`}
              >
                {selectedRowsData[field] ? "Enabled" : "Disabled"}
              </span>
            </div>
          </div>

          <div className="form-check form-switch m-0">
            <input
              className="form-check-input"
              type="checkbox"
              checked={selectedRowsData[field]}
              onChange={() => sendHardwareCommand(selectedRowsData, field)}
              style={{
                width: 55,
                height: 28,
                cursor: "pointer",
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );

  const customTableStyles = {
    headRow: {
      style: {
        backgroundColor: "#EFF2F7",
        borderBottom: "2px solid #e9ecef",
        minHeight: "48px",
      },
    },
    headCells: {
      style: {
        fontSize: "14px",
        letterSpacing: "0.03em",
        paddingLeft: "16px",
        paddingRight: "16px",
        color: "#000000",
        fontWeight: 700,
      },
    },
    rows: {
      style: {
        minHeight: "56px",
        fontSize: "14px",
        "&:not(:last-of-type)": {
          borderBottomColor: "#f1f3f5",
        },
      },
      highlightOnHoverStyle: {
        backgroundColor: "#f8f9fa",
        transitionDuration: "0.15s",
      },
    },
    cells: {
      style: {
        paddingLeft: "16px",
        paddingRight: "16px",
      },
    },
    pagination: {
      style: {
        borderTop: "1px solid #e9ecef",
        minHeight: "48px",
      },
    },
  };

  const sceneColumns = [
    {
      name: <span>Scene</span>,
      selector: (row: any) => row.sceneName,
      sortable: true,
      grow: 2,
      cell: (row: any) => (
        <div className="fw-semibold text-dark">{row.sceneName}</div>
      ),
    },
    {
      name: <span>Action</span>,
      center: true,
      cell: (row: any) => (
        <span
          className={`badge rounded-pill px-3 py-2 d-inline-flex align-items-center gap-1 ${
            row.isOn ? "bg-success  text-white" : "bg-danger  text-white"
          }`}
        >
          {row.isOn ? "ON" : "OFF"}
        </span>
      ),
    },
    ...(!isScenePanelType(selectedSceneModelType)
      ? [
          {
            name: <span>Brightness</span>,
            center: true,
            cell: (row: any) => (
              <div
                className="d-flex align-items-center justify-content-center gap-2"
                style={{ width: "100%" }}
              >
                <span className="fw-semibold " style={{ minWidth: "36px" }}>
                  {row.dimmerValue}
                </span>
              </div>
            ),
          },
        ]
      : []),
  ];

  const customScheduleTableStyles = {
    headRow: {
      style: {
        backgroundColor: "#EFF2F7",
        borderBottom: "2px solid #e9ecef",
        minHeight: "46px",
      },
    },
    headCells: {
      style: {
        fontSize: "14px",
        fontWeight: 700,
        letterSpacing: "0.03em",
        color: "#000000",
      },
    },
    rows: {
      style: {
        minHeight: "60px",
        fontSize: "14px",
      },
    },
    pagination: {
      style: {
        borderTop: "1px solid #e9ecef",
      },
    },
  };

  const scheduleColumns = [
    {
      name: "Time",
      selector: (row: any) => row.time,
      sortable: true,
      width: "130px",
    },
    {
      name: "Next Run",
      selector: (row: any) => row.nextRun,
      sortable: true,
      grow: 2,
    },
    {
      name: "Execute",
      grow: 2,
      cell: (row: any) => {
        const execute = getExecuteValue(row.executeValue);  
        return (
          <div>
            <div
              className={`badge rounded-pill p-2 ${
                execute.isOn ? "bg-success text-white" : "bg-danger text-white"
              }`}
            >
              Switch {execute.isOn ? "ON" : "OFF"}
            </div>
          </div>
        );
      },
    },
    ...(!isScenePanelType(selectedSwitchModelType)
      ? [
          {
            name: " Brightness",
            center: true,
            cell: (row: any) => {
              const execute = getExecuteValue(row.executeValue);

              return (
                <div>
                  <div className="mt-1">
                    <div className="fw-semibold">{execute.dimming}</div>
                  </div>
                </div>
              );
            },
          },
        ]
      : []),
    {
      name: "Repeat",
      center: true,
      cell: (row: any) =>
        row.isRepeat ? (
          <span className="badge bg-info bg-opacity-1 text-black py-2 px-3 fs-7">
            Yes
          </span>
        ) : (
          <span className="badge bg-secondary bg-opacity-6 text-white py-2 px-3 fs-7 ">
            No
          </span>
        ),
    },
    {
      name: "Status",
      center: true,
      cell: (row: any) => (
        <div className="d-flex align-items-center">
          <div
            style={{
              width: 10,
              height: 10,
              borderRadius: "50%",
              background: row.isActive ? "#22C55E" : "#EF4444",
              marginRight: 8,
            }}
          />

          <b>{row.isActive ? "Active" : "Inactive"}</b>
        </div>
      ),
    },
    {
      name: "Actions",
      center: true,
      width: "110px",
      cell: (row: any) => (
        <div className="d-flex align-items-center">
          <button
            type="button"
            className="btn btn-sm"
            title="Edit schedule"
            onClick={() => handleEditSchedule(row)}
          >
            <i className="bx bx-edit-alt text-primary fs-5"></i>
          </button>
         <button
          type="button"
          className="btn btn-sm "
          title="Delete schedule"
          disabled={deletingScheduleId === getScheduleId(row)}
          onClick={() => handleDeleteSchedule(row)}
        >
          <i className="bx bx-trash text-danger fs-5"></i>
        </button>
        </div>
      ),
    },
  ];

  const getExecuteValue = (value: string) => {
    if (!value)
      return {
        dimming: "-",
        state: "-",
        isOn: false,
      };

    const dimming = value.substring(0, value.length - 1);
    const state = value.slice(-1);

    return {
      dimming,
      state,
      isOn: state === "1",
    };
  };

  const ScheduleStat = ({
    value,
    label,
    color,
  }: {
    value: number | string;
    label: string;
    color: string;
  }) => (
    <div
      className="text-center rounded-3 py-3 h-100"
      style={{
        backgroundColor: "#ffffff",
        border: "1px solid #e9ecef",
      }}
    >
      <h3 className="fw-bold mb-0 fs-2" style={{ color }}>
        {value}
      </h3>
      <span className="text-muted">{label}</span>
    </div>
  );

  // assign scene panel
  const getSceneId = (scene: any) =>
  String(scene?.id ?? scene?._id ?? scene?.sceneId ?? scene?.scene_id ?? "");

  const getSceneName = (scene: any) =>
    String(scene?.name ?? scene?.sceneName ?? scene?.title ?? "Unnamed Scene");

  const getSceneDevices = (scene: any) => {
    const switches = Array.isArray(scene?.switches)
      ? scene.switches
      : [];

    const remotes = Array.isArray(scene?.remotes)
      ? scene.remotes
      : [];

    return {
      switches,
      remotes,
    };
  };

  return (
    <div>
      {alertSlaveAirModel.map((chip) => (
        <div
          key={chip.slave}
          className="alert fw-bold text-white"
          role="alert"
          style={{ backgroundColor: "#c43429" }}
        >
          Touch code update required in Slave{" "}
          <strong>
            {chip.slave} - {chip.roomName}
          </strong>
          &nbsp; (Model: {chip.modelType}, HW: {chip.hwVersion})
        </div>
      ))}

      {isDeleteModalOpen && (
        <ConfirmationModal
          headerTitle="Delete Chip?"
          text="Are you sure you want to delete this Chip ? This action cannot be undone."
          buttonText="Delete"
          onClick={() => {
            deleteChipApiCall();
          }}
          cancleBtnClick={() => setDeleteModalOpen(false)}
          loading={loading}
        />
      )}
      {isOtaModalOpen && (
        <OtaModel
          headerTitle="OTA"
          otaSlave={otaSlave}
          cancleBtnClick={() => setIsOtaModalOpen(false)}
        />
      )}
      {isMultiOtaModalOpen && (
        <OtaMultiModel
          headerTitle="SELECTED OTA"
          selectedRows={selectedRows}
          cancleBtnClick={() => setIsMultiOtaModalOpen(false)}
        />
      )}
      {isMqttBoxModalOpen && (
        <MqttBoxModel
          headerTitle="MQTT Box"
          MqttData={MqttData}
          cancleBtnClick={() => setIsMqttBoxModalOpen(false)}
        />
      )}
      {isAssignRoomModalOpen && (
        <AssignRoomModal
          headerTitle="Assign Room"
          idName={"Chiplist"}
          assignData={assignData}
          handleRefresh={handleRefresh}
          cancleBtnClick={() => {
            setIsAssignRoomModalOpen(false);
            setAssignData({});
          }}
        />
      )}
      {/* {offcanvasOpenBinding && ( */}
      <DeviceBinding
        offcanvasOpen={offcanvasOpenBinding}
        closeOffcanvas={handleBinding}
        userId={userId}
        selectedPremise={selectedPremise}
      />
      {/* )} */}

      {isWifiModalOpen && (
        <WifiModal
          selectedRows={selectedRows}
          deviceType="chip"
          handleRefresh={handleRefresh}
          cancleBtnClick={() => setIsWifiModalOpen(false)}
        />
      )}
      {/* for assing scene panel */}
      {isDeleteSceneModalOpen && (
        <ConfirmationModal
          headerTitle="Remove Scene?"
          text="Are you sure you want to remove this scene from the switch? This action cannot be undone."
          buttonText="Delete"
          onClick={() => {
            deleteSceneAssignApiCall();
          }}
          cancleBtnClick={closeDeleteSceneModal}
          loading={deletingScene}
        />
      )}

      <ScheduleFormOffcanvas
        show={isScheduleFormOpen}
        onClose={closeScheduleForm}
        onSaved={handleRefresh}
        userId={userId}
        selectedPremise={selectedPremise}
        editingSchedule={editingSchedule}
      />


      <Modal
        isOpen={isViewModalOpen}
        role="dialog"
        autoFocus={true}
        centered={true}
        className="exampleModal"
        // tabIndex="-1"
        toggle={toggleRequestModel}
      >
        <div className="modal-content">
          <ModalHeader>
            <div className="w-100">
              <h5 className="mb-1">Device Settings</h5>

              <small className="text-muted">
                {selectedRowsData.slave} • {selectedRowsData.modelType}
              </small>
            </div>
          </ModalHeader>
          <ModalBody style={{ background: "#f8f9fa" }}>
            <div className="row">
              <SettingCard
                title="Recall"
                description="Restore previous state after power on"
                field="recall"
              />

              {!hideIrAndMainLight && (
                <>
                  <SettingCard
                    title="IR Remote"
                    description="Enable IR learning mode"
                    field="ir_set"
                  />

                  <SettingCard
                    title="Main Light"
                    description="Green indicator LED"
                    field="mainlit"
                  />
                </>
              )}

              <SettingCard
                title="Back Light"
                description="White touch backlight"
                field="backlit"
              />
            </div>
          </ModalBody>

          <ModalFooter className="justify-content-end">
            <button
              className="btn btn-outline-secondary"
              onClick={toggleRequestModel}
            >
              Close
            </button>
          </ModalFooter>
        </div>
      </Modal>

      <Modal
        isOpen={sceneModal}
        toggle={closeSceneModal}
        centered
        size="lg"
        className="shadow "
      >
        <ModalHeader
          toggle={closeSceneModal}
          className="border-bottom py-3 px-4"
          style={{ background: "#F8FAFC" }}
        >
          <div className="d-flex align-items-center gap-2">
            <div>
              <h5 className="fw-bold mb-0 text-dark fs-3 ">Scene Manager</h5>
              <small className="text-muted fs-5">
                {selectedSceneSwitch?.displayName}
              </small>
            </div>
          </div>
        </ModalHeader>

        <ModalBody style={{ background: "#F8FAFC" }}>
          <div className="border rounded-3 overflow-hidden">
            <DataTable
              columns={sceneColumns}
              data={selectedSceneSwitch?.usedInScenes || []}
              customStyles={customTableStyles}
              pagination
              paginationPerPage={5}
              fixedHeader
              fixedHeaderScrollHeight="420px"
              highlightOnHover
              responsive
            />
          </div>
        </ModalBody>
      </Modal>

      <Modal
        isOpen={scheduleModal}
        toggle={closeScheduleModal}
        centered
        size="xl"
        className="shadow"
        role="dialog"
      >
        <ModalHeader
          toggle={closeScheduleModal}
          className="border-0 py-3 px-4 bg-[#F8FAFC]"
          style={{ background: "#F8FAFC" }}
        >
          <div className="d-flex align-items-center justify-content-between w-100 gap-2">
            <div>
              <div className="d-flex gap-2 pt-2">
                <h4 className="mb-0 fw-bold text-dark fs-3 ">
                  Schedule Manager
                </h4>
                <div className="badge bg-success rounded-pill px-3 py-2  ">
                  {selectedSwitch?.displayName}
                </div>
              </div>
              <div className="mt-2 fs-5 ">
                Manage switch schedules : {selectedSwitch?.button}
              </div>
            </div>

            <div className="">
              <div className="small text-muted "></div>
            </div>
          </div>
        </ModalHeader>

        <ModalBody style={{ background: "#F8FAFC", padding: 20 }}>
          <div className="row mb-3 g-3">
            <div className="col-md-4">
              <ScheduleStat
                value={selectedSwitch?.schedules?.length || 0}
                label="Total"
                color="#4f46e5"
              />
            </div>
            <div className="col-md-4">
              <ScheduleStat
                value={
                  selectedSwitch?.schedules?.filter((x: any) => x.isActive)
                    .length || 0
                }
                label="Active"
                color="#22C55E"
              />
            </div>
            <div className="col-md-4">
              <ScheduleStat
                value={
                  selectedSwitch?.schedules?.filter((x: any) => !x.isActive)
                    .length || 0
                }
                label="Inactive"
                color="#EF4444"
              />
            </div>
          </div>

          <div
            className="rounded-3 overflow-hidden"
            style={{ backgroundColor: "#fff", border: "1px solid #e9ecef" }}
          >
            <DataTable
              columns={scheduleColumns}
              data={selectedSwitch?.schedules || []}
              customStyles={customScheduleTableStyles}
              pagination
              fixedHeader
              fixedHeaderScrollHeight="420px"
              highlightOnHover
              responsive
            />
          </div>
        </ModalBody>
      </Modal>
      <Modal
        isOpen={addSceneModalOpen}
        toggle={closeAddSceneModal}
        centered
        size="lg"
        className="shadow "
      >
        <ModalHeader
          toggle={closeAddSceneModal}
          className="border-bottom py-3 px-4"
          style={{ background: "#F8FAFC" }}
        >
          <div>
            <h5 className="fw-bold mb-0 text-dark fs-3">Add Scene</h5>
            <small className="text-muted fs-5">
              {selectedSwitchForScene?.displayName}
            </small>
          </div>
        </ModalHeader>

        <ModalBody
          className="overflow-y-auto"
          style={{ background: "#F8FAFC", height: "50vh" }}
        >
          {scenesLoading ? (
            <div className="text-center py-4">Loading scenes...</div>
          ) : availableScenes.length === 0 ? (
            <div className="text-center py-4 text-muted">
              No scenes available
            </div>
          ) : (
            <div className="d-flex flex-column gap-2">
              {availableScenes.map((scene: any, idx: number) => {
                const sceneId = getSceneId(scene);
                const sceneName = getSceneName(scene);

                const rowKey =
                  sceneId || `scene-${idx}`;

                const isExpanded =
                  expandedSceneDevicesId === rowKey;

                const devices =
                  getSceneDevices(scene);

                return (
                  <div
                    key={rowKey}
                    className="border rounded-3"
                    style={{
                      backgroundColor: "#fff",
                      borderColor: "#E4E7EC",
                    }}
                  >
                    {/* ================= SCENE ROW ================= */}
                    <div
                      className="d-flex align-items-center justify-content-between px-3 py-2"
                      style={{
                        minHeight: "48px",
                      }}
                    >
                      {/* Left */}
                      <div className="d-flex align-items-center gap-2">
                        <input
                          type="radio"
                          name="sceneSelect"
                          checked={
                            selectedSceneToAssign ===
                            sceneId
                          }
                          onChange={() =>
                            setSelectedSceneToAssign(
                              sceneId,
                            )
                          }
                          disabled={!sceneId}
                          style={{
                            cursor: "pointer",
                            width: "16px",
                            height: "16px",
                          }}
                        />
                        <div>
                          <div
                            className="fw-semibold"
                            style={{
                              fontSize: "13px",
                              color: "#101828",
                            }}
                          >
                            {sceneName}
                          </div>
                        </div>
                      </div>

                      {/* Right */}
                      <button
                        type="button"
                        className="btn btn-sm d-flex align-items-center justify-content-center p-0"
                        onClick={() =>
                          setExpandedSceneDevicesId(
                            isExpanded ? null : rowKey,
                          )
                        }
                        title={
                          isExpanded
                            ? "Hide devices"
                            : "View devices"
                        }
                        style={{
                          border: "none",
                        }}
                      >
                        <i
                          className={`bx ${
                            isExpanded
                              ? "bx-show"
                              : "bx-show-alt"
                          }`}
                          style={{
                            fontSize: "18px",
                          }}
                        />
                      </button>
                    </div>

                    {/* ================= EXPANDED DETAILS ================= */}
                    {isExpanded && (
                      <div
                        className="px-3 pb-3"
                        style={{
                          borderTop:
                            "1px solid #EAECF0",
                          backgroundColor: "#F8FAFC",
                        }}
                      >
                        {/* ================= SWITCHES ================= */}
                        {devices.switches.length > 0 && (
                          <div className="pt-3">
                            <div className="d-flex align-items-center gap-2 mb-2">
                            
                              <span
                                className="fw-semibold"
                                style={{
                                  fontSize: "12px",
                                  color: "#344054",
                                }}
                              >
                                Switches
                              </span>

                              <span
                                className="badge rounded-pill"
                                style={{
                                  backgroundColor:
                                    "#F2F4F7",
                                  color: "#475467",
                                  border:
                                    "1px solid #EAECF0",
                                  fontSize: "10px",
                                }}
                              >
                                {devices.switches.length}
                              </span>
                            </div>

                            <div
                              className="border rounded-3 overflow-hidden"
                              style={{
                                backgroundColor: "#fff",
                                borderColor: "#E4E7EC",
                              }}
                            >
                              <DataTable
                                columns={[
                                  {
                                    name: "Slave",
                                    selector: (row: any) =>
                                      row?.slave || "-",
                                    sortable: true,
                                    wrap: true,
                                    width:"160px"
                                  },

                                  {
                                    name: "Display Name",
                                    selector: (row: any) =>
                                    row?.displayName || "-",
                                    sortable: true,
                                    grow: 1.5,
                                    wrap: true,
                                    width: "120px"

                                  },

                                  {
                                    name: "Button",
                                    selector: (row: any) =>
                                    row?.button ?? "-",
                                    sortable: true,
                                    center: true,
                                    width:"100px"
                                  },

                                  {
                                    name: "Type",
                                    selector: (row: any) =>
                                      row?.type === 1
                                        ? "Dimmer"
                                        : "Switch",
                                    sortable: true,
                                    center: true,
                                    width:"100px"
                                  },

                                  {
                                    name: "On / Off",
                                    selector: (row: any) =>
                                      row?.isOn
                                        ? "ON"
                                        : "OFF",

                                    cell: (row: any) =>
                                      row?.isOn ? (
                                        <span
                                          className="badge rounded-pill"
                                          style={{
                                            backgroundColor:
                                              "#ECFDF3",
                                            color:
                                              "#027A48",
                                            border:
                                              "1px solid #ABEFC6",
                                            fontSize: "10px",
                                          }}
                                        >
                                          ON
                                        </span>
                                      ) : (
                                        <span
                                          className="badge rounded-pill"
                                          style={{
                                            backgroundColor:
                                              "#FEF3F2",
                                            color:
                                              "#B42318",
                                            border:
                                              "1px solid #FECDCA",
                                            fontSize: "10px",
                                          }}
                                        >
                                          OFF
                                        </span>
                                      ),
                                    sortable: true,
                                    width:"100px",
                                    center: true,
                                  },
                                  {
                                    name: "Dimmer",
                                    selector: (row: any) =>
                                      row?.dimmerValue ??
                                      "-",
                                    sortable: true,
                                    center: true,
                                    width:"100px"
                                  },
                                ]}
                                data={devices.switches}
                                dense
                                highlightOnHover
                                responsive
                                noHeader
                                customStyles={
                                  customStyles
                                }
                                noDataComponent="No switches available"
                              />
                            </div>
                          </div>
                        )}
                        {/* ================= REMOTES ================= */}
                        {devices.remotes.length > 0 && (
                          <div className="pt-3">
                            <div className="d-flex align-items-center gap-2 mb-2">
                              <i
                                className="bx bx-remote"
                                style={{
                                  fontSize: "17px",
                                  color: "#667085",
                                }}
                              />
                              <span
                                className="fw-semibold"
                                style={{
                                  fontSize: "12px",
                                  color: "#344054",
                                }}
                              >
                                Remotes
                              </span>
                              <span
                                className="badge rounded-pill"
                                style={{
                                  backgroundColor:
                                    "#F2F4F7",
                                  color: "#475467",
                                  border:
                                    "1px solid #EAECF0",
                                  fontSize: "10px",
                                }}
                              >
                                {devices.remotes.length}
                              </span>
                            </div>
                            <div
                              className="border rounded-3 overflow-hidden"
                              style={{
                                backgroundColor: "#fff",
                                borderColor: "#E4E7EC",
                              }}
                            >
                              <DataTable
                                columns={[
                                  {
                                    name: "Slave",
                                    selector: (row: any) =>
                                      row?.slave || "-",
                                    sortable: true,
                                    wrap: true,
                                  },

                                  {
                                    name: "Type",
                                    selector: (row: any) =>
                                      row?.type ?? "-",
                                    sortable: true,
                                    center: true,
                                  },

                                  {
                                    name: "On / Off",
                                    selector: (row: any) =>
                                      row?.isOn
                                        ? "ON"
                                        : "OFF",

                                    cell: (row: any) =>
                                      row?.isOn ? (
                                        <span
                                          className="badge rounded-pill"
                                          style={{
                                            backgroundColor:
                                              "#ECFDF3",
                                            color:
                                              "#027A48",
                                            border:
                                              "1px solid #ABEFC6",
                                            fontSize: "10px",
                                          }}
                                        >
                                          ON
                                        </span>
                                      ) : (
                                        <span
                                          className="badge rounded-pill"
                                          style={{
                                            backgroundColor:
                                              "#FEF3F2",
                                            color:
                                              "#B42318",
                                            border:
                                              "1px solid #FECDCA",
                                            fontSize: "10px",
                                          }}
                                        >
                                          OFF
                                        </span>
                                      ),
                                    sortable: true,
                                    center: true,
                                  },
                                  {
                                    name: "Brand Name",
                                    selector: (row: any) =>
                                      row?.brandName ||
                                      "-",
                                    sortable: true,
                                    wrap: true,
                                  },
                                  {
                                    name: "Brand Model",
                                    selector: (row: any) =>
                                      row?.brandModal ||
                                      row?.brandModel ||
                                      "-",
                                    sortable: true,
                                    wrap: true,
                                  },
                                ]}
                                data={devices.remotes}
                                dense
                                highlightOnHover
                                responsive
                                noHeader
                                customStyles={
                                  customStyles
                                }
                                noDataComponent="No remotes available"
                              />
                            </div>
                          </div>
                        )}

                        {/* No devices */}
                        {devices.switches.length === 0 &&
                          devices.remotes.length === 0 && (
                            <div
                              className="text-center py-3 text-muted"
                              style={{
                                fontSize: "12px",
                              }}
                            >
                              No switches or remotes
                              available in this scene.
                            </div>
                          )}
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          )}
        </ModalBody>

        <ModalFooter className="justify-content-end">
          <button
            className="btn btn-outline-secondary"
            onClick={closeAddSceneModal}
          >
            Cancel
          </button>
          <Button
            color="dark"
            disabled={assigningScene || !selectedSceneToAssign}
            onClick={handleAssignSceneSubmit}
          >
            {assigningScene ? "Assigning..." : "Assign Scene"}
          </Button>
        </ModalFooter>
      </Modal>
      <ChipsDataTable
        apiURL={`${url.BASE_URL}${url.GET_CHIPS_LIST}`}
        title="Chip List"
        customStyles={customStyles}
        selectedRoomID={selectedRooms}
        columns={columns}
        isReload={isReload}
        expandableRows={true}
        ExpandedComponent={ExpandedComponent}
        ExpandCollapseIcon={ExpandCollapseIcon}
        idName={"Chiplist"}
        loading={loading}
        setLoading={setLoading}
        selectedRows={selectedRows}
        setSelectedRows={setSelectedRows}
        handlePingAll={handlePingAll}
        handleDsAll={handleDsAll}
        handleDeleteAll={handleDeleteAll}
        handleUpdateWifiAll={handleUpdateWifiAll}
        handleOtaAll={handleOtaAll}
        userId={userId}
        setChipData={setChipData}
        handleBinding={handleBinding}
        showBindingButton={selectedPremise?.isParent === false}
      />
    </div>
  );
};

export default ChipsList;

export const customStyles: any = {
 
  subHeader: {
    style: {
      padding: "0px",
      margin: "0px",
    },
  },
  headRow: {
    style: {
      backgroundColor: "#EFF2F7",
      fontWeight: "bold",
      fontSize: "14px",
      borderBottom: "none",
      padding: "0px !important",
    },
  },
  headCells: {
    style: {
      padding: "0px 2px",
      margin: "0px",
    },
  },

  rows: {
    style: {
      fontSize: "14px",
      color: "#343a40",
      borderBottom: "none",
    },
  },
  cells: {
    style: {
      fontSize: "14px",
      color: "#343a40",
      borderBottom: "none",
      padding: "0px 2px !important",
    },
  },
};

export const ExpandCollapseIcon = ({ expanded }: { expanded: boolean }) => {
  return (
    <div
      className="d-flex justify-content-center align-items-center  "
      style={{ cursor: "pointer", width: "32px", height: "32px" }}
    >
      <i
        className={`bx ${
          expanded ? "bx-caret-down" : "bx-caret-right"
        } text-dark fs-5`}
      ></i>
    </div>
  );
};